import { Configuration, LogLevel } from '@azure/msal-browser';
import { fetchRuntimeConfig } from '../utils/config';

// Create dynamic MSAL configuration
export const createMsalConfig = async (): Promise<Configuration> => {
  const config = await fetchRuntimeConfig();

  return {
    auth: {
      clientId: config.REACT_APP_AZURE_CLIENT_ID || '',
      authority: `https://login.microsoftonline.com/${config.REACT_APP_AZURE_TENANT_ID || 'common'}`,
      redirectUri: config.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
      postLogoutRedirectUri: config.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
    },
    cache: {
      cacheLocation: 'sessionStorage', // Store tokens in sessionStorage for security
      storeAuthStateInCookie: false, // Set to true for IE11 or Edge compatibility
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;

          switch (level) {
            case LogLevel.Error:
              console.error('[MSAL]', message);
              break;
            case LogLevel.Info:
              console.info('[MSAL]', message);
              break;
            case LogLevel.Verbose:
              if (config.REACT_APP_ENVIRONMENT === 'development') {
                console.log('[MSAL]', message);
              }
              break;
            case LogLevel.Warning:
              console.warn('[MSAL]', message);
              break;
          }
        },
        piiLoggingEnabled: false,
        logLevel: config.REACT_APP_ENVIRONMENT === 'development' ? LogLevel.Info : LogLevel.Error,
      },
    },
  };
};

// Fallback static configuration for cases where dynamic config isn't available
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin, // Use current origin
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Store tokens in sessionStorage for security
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge compatibility
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;

        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message);
            break;
          case LogLevel.Info:
            console.info('[MSAL]', message);
            break;
          case LogLevel.Verbose:
            if (process.env.NODE_ENV === 'development') {
              console.log('[MSAL]', message);
            }
            break;
          case LogLevel.Warning:
            console.warn('[MSAL]', message);
            break;
        }
      },
      piiLoggingEnabled: false,
      logLevel: process.env.NODE_ENV === 'development' ? LogLevel.Info : LogLevel.Error,
    },
    // Removed allowNativeBroker as it is not a valid property of BrowserSystemOptions
  },
};

// Add scopes here for your API calls
export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read'], // Basic scopes for user info
};

// Scopes needed for BigTime API (if needed)
export const bigTimeApiRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
};

// Graph API request (example for additional Microsoft services)
export const graphRequest = {
  scopes: ['https://graph.microsoft.com/User.Read'],
};
